import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from "@mui/icons-material/Phone";
import { Typography, useTheme } from "@mui/material";
import SEO from "../seo/SEO";
import "./Kontakt.css";
import KontaktFormular from './KontaktFormular';

export default function Kontakt() {
  const theme = useTheme();
  return (
    <div id="kontakt-background">
      <SEO
        title="Kontakt"
        description="Termin vereinbaren für Pferdeosteopathie in Hamburg. Telefon +49 1575 3382952, E-Mail info@pferdeosteopathie-laskowski.de oder über das Kontaktformular."
        breadcrumbs={[
          { name: "Start", path: "/" },
          { name: "Kontakt", path: "/kontakt" },
        ]}
      />
      <div
        id="kontakt-shadow"
      >
        <div className="kontakt-box" style={{
          color: theme.palette.primary.main
        }}>
          <Typography variant="h2" component="h1" textAlign="center" className='kontakt-h2'>
            Vielen Dank für dein Interesse!
          </Typography>
          <hr className='kontakt-hr' style={{backgroundColor: theme.palette.primary.main}} />
          <div className="kontakt-zeile">
            <PhoneIcon />
              <a href="tel:+4915753382952" className='kontakt-link' >
                +49 1575 3382952
              </a>
          </div>
          <div className="kontakt-zeile">
            <EmailIcon />
              <a href="mailto:info@pferdeosteopathie-laskowski.de" className='kontakt-link' >
                info@pferdeosteopathie-laskowski.de
              </a>
          </div>
          <hr className='kontakt-hr' style={{backgroundColor: theme.palette.primary.main}} />
          <KontaktFormular />
        </div>
      </div>
    </div>
  );
}
